<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li
        class="nav-item"
        v-for="{ id, icono, nombre, url_nombre } in modulosAcceso"
        :key="id"
      >
        <sidenav-item
          :url="url_nombre"
          :class="getRoute() == url_nombre ? 'active' : ''"
          :navText="nombre"
        >
          <template v-slot:icon>
            <i :class="icono" class="mb-1 text-white text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item url="factoraje" class="" navText="Factoraje">
          <template v-slot:icon>
            <i
              class="mb-1 text-white text-sm opacity-10 ri-exchange-dollar-fill"
            ></i>
          </template>
        </sidenav-item>
      </li>
    </ul>
  </div>
  <div class="pt-3 mx-3 mt-3 sidenav-footer">
    <sidenav-card
      :class="cardBg"
      textPrimary="Need Help?"
      textSecondary="Please check our docs"
    />
  </div>
</template>
<script>
import SidenavItem from "./SidenavItem";
import SidenavCard from "./SidenavCard";
import { useLogin } from "@/composables/useAuth";
import { ref } from "vue";

export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data() {
    return {
      title: "Argon Dashboard 2",
      controls: "dashboardsExamples",
      isActive: "active",
    };
  },
  components: {
    SidenavItem,
    SidenavCard,
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.matched[1].name;
      return routeArr[1];
    },
  },
  setup() {
    const { _modulos } = localStorage;

    if (!_modulos) {
      return;
    }

    const modulosAcceso = ref(JSON.parse(_modulos));

    return {
      modulosAcceso,
    };
  },
};
</script>
